import React from 'react';

// Props
type Props = {
  className?: string;
  height: number;
};

// Component
const BatterySVG: React.FC<Props> = ({ className, height }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 20" className={className}>
    <path
      d="M6.87 1.33V0H3.12v1.33H1.08C.49 1.33 0 1.85 0 2.49v16.36C0 19.48.49 20 1.08 20h7.84c.59 0 1.08-.52 1.08-1.15V2.49c0-.64-.49-1.16-1.08-1.16H6.87z"
      fill="#c7cac7"
    />
    <path
      d="M6.88 1.33V0H3.13v1.33H1.08C.49 1.33 0 1.85 0 2.49v16.36C0 19.48.49 20 1.08 20h7.84c.59 0 1.08-.52 1.08-1.15V2.49c0-.64-.49-1.16-1.08-1.16H6.88z"
      // fill={"#43b05c"}
      fill={height > 50 ? 'green' : height > 25 ? 'yellow' : 'red'}
      clipPath={`inset(${100 - height}% 0 0 0)`}
    />
  </svg>
);

export default BatterySVG;
